export const ProductDetailsPublish = () => {
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">제품 상세보기</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-outline-dark">
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />제품삭제
                        </button>
                    </div>
                </div>

                <h5 className="subheading">기본정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr className="h-166px">
                            <th style={{ width: "16.66%" }}>상품정보</th>
                            <td colSpan={3}>
                                <div className="line0 mb-5px">[Microsoft] Compact</div>
                                <div className="line1 mb-3px">S1-WIN Emb Compact 7 C7E</div>
                                <div className="line2 mb-16px">TNA-00022</div>
                                <div className="line3_lg">설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다.<br />
                                    설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다.</div>
                            </td>
                        </tr>
                        <tr>
                            <th>생성일자</th>
                            <td style={{ width: "31.3%" }}>2024-05-05</td>
                            <th style={{ width: "16.66%" }}>생성자</th>
                            <td style={{ width: "31.3%" }}>이소희</td>
                        </tr>
                    </tbody>

                </table>

                <h5 className="subheading">품목 정보</h5>

                <table className="table table-bordered my_table">
                    <thead>
                        <tr>
                            <th style={{ width: "16.66%" }}>벤더</th>
                            <th style={{ width: "16.66%" }}>카테고리</th>
                            <th style={{ width: "16.66%" }}>품목</th>
                            <th style={{ width: "16.66%" }}>규격</th>
                            <th style={{ width: "16.66%" }}>대분류</th>
                            <th style={{ width: "16.66%" }}>중분류</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-center">MS</td>
                            <td className="text-center">CSP</td>
                            <td className="text-center">S1-WIN...</td>
                            <td className="text-center"></td>
                            <td className="text-center"></td>
                            <td className="text-center"></td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">상세정보</h5>
                <div className="product_detail_container">
                    <div className="left">
                        <div className="img_outer">
                            <button className="btn btn-info color2 w-100px px-0 position-absolute"><img src={process.env.PUBLIC_URL + "/assets/images/icon_download.png"} alt="" />다운로드</button>
                            <div style={{ background: "url(" + process.env.PUBLIC_URL + "/assets/images/ex_image_xl.png)", backgroundRepeat: "no-repeat", backgroundSize: "auto", backgroundPosition: "center" }}></div>
                        </div>
                        <button className="btn btn-outline-secondary d-block m-auto w-140px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cam_sm.png"} alt="" />이미지 변경</button>
                    </div>
                    <div className="right">
                        <div className="right_top">
                            <table className="table table_form m-0 w-100 border-0">
                                <tbody>
                                    <tr>
                                        <td>적용환율</td>
                                        <td>
                                            <div className="d-flex">
                                                <input type="text" className="form-control w-150px h-34px" />
                                                <input type="text" className="form-control w-150px h-34px ms-5px" />
                                                <input type="text" className="form-control w-150px h-34px ms-5px" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>결제수단</td>
                                        <td>현금</td>
                                    </tr>
                                    <tr>
                                        <td>결제예정일</td>
                                        <td><input type="date" className="form-control w-150px h-34px" /></td>
                                    </tr>
                                    <tr>
                                        <td>배송정보</td>
                                        <td>제품키 발송</td>
                                    </tr>
                                    <tr>
                                        <td>배송비</td>
                                        <td>무료배송</td>
                                    </tr>
                                    <tr>
                                        <td>배송방법</td>
                                        <td>
                                            <select className="form-select w-150px">
                                                <option>택배</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="pt-15px" style={{ verticalAlign: "top" }}>배송지</td>
                                        <td>
                                            <div>
                                                <select className="form-select w-150px">
                                                    <option>1사업장</option>
                                                </select>
                                            </div>
                                            <div className="d-flex mt-6px">
                                                <input type="text" className="form-control w-150px h-34px" />
                                                <button className="btn btn-secondary w-80px ms-5px text-nowrap">주소 검색</button>
                                                <input type="text" className="form-control ms-5px h-34px" />
                                            </div>
                                            <div className="d-flex mt-6px">
                                                <input type="text" className="form-control h-34px" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>납품희망일</td>
                                        <td><input type="date" className="form-control w-150px h-34px" /></td>
                                    </tr>
                                </tbody>

                            </table>
                        </div>
                        <div className="right_btm">
                            <div className="right_btm_wrapper">
                                <div className="left">
                                    <div className="line1">S1-WIN Emb Compact 7 C7E</div>
                                    <div className="line2">TNA-00022</div>
                                    <div className="input-group input_magic_control mb-3">
                                        <span className="input-group-text">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_minus_btn.png"} alt="" />
                                        </span>
                                        <input type="text" className="form-control" aria-label="Amount (to the nearest dollar)" />
                                        <span className="input-group-text">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_plus_btn.png"} alt="" />
                                        </span>
                                    </div>
                                </div>
                                <div className="right">
                                    <div className="total">239,800원</div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end align-items-center mt-25px mb-15px">
                            <button className="btn btn-outline-dark w-100px h-38px px-0"><img className="me-5px" src={process.env.PUBLIC_URL + "/assets/images/icon_shopping_cart.png"} alt="" />장바구니</button>
                            <button className="btn btn-dark w-100px h-38px ms-5px">구매하기</button>
                        </div>
                    </div>
                </div>

                <div className="table_top">
                    <h6 className="table_stats">이전 결제 내역(<span>19</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-info w-100px h-38px">적용하기</button>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th style={{ width: "4.4%" }}></th>
                                <th style={{ width: "8.8%" }}>구매 일자 <a href="#/sort-1" className="btn btn-link p-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_sort.png"} alt="" /></a></th>
                                <th style={{ width: "22%" }}>제품</th>
                                <th style={{ width: "11.94%" }}>규격</th>
                                <th style={{ width: "8.8%" }}>수량</th>
                                <th style={{ width: "26.4%" }} colSpan={3}>환율</th>
                                <th style={{ width: "8.8%" }}>배송방법</th>
                                <th>상태</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => (<tr>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                        />
                                    </div>
                                </td>
                                <td className="text-center">2024.01.10</td>
                                <td>S1-WIN Emb Compact 7 C7E</td>
                                <td className="text-center">MUV-1234</td>
                                <td className="text-center">1</td>
                                <td style={{ width: "8.8%" }} className="text-center">일평균</td>
                                <td style={{ width: "8.8%" }} className="text-center">최초고시</td>
                                <td className="text-center">송금 보낼 때</td>
                                <td className="text-center">택배</td>
                                <td className="text-center">배송중</td>
                            </tr>))}
                        </tbody>
                    </table>
                </div>
                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}